import React, { useEffect, useRef } from "react";

const Opensource = () => {
  return (
    // Under Construction
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        overflow: "hidden",
      }}
    >
      <iframe src="https://documentation-app-nu.vercel.app/api/%F0%9F%94%B9-get-temperature-by-client/" width="100%" height="100%" frameborder="0"></iframe> 
    </div>
  );
};

export default Opensource;
